import { render, staticRenderFns } from "./ReportProductByCustomer.vue?vue&type=template&id=6a8273cf&"
import script from "./ReportProductByCustomer.vue?vue&type=script&lang=js&"
export * from "./ReportProductByCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports